import { GET_CONDITION_VARIABLES_ACTION } from '../store/conditionVariables';

export default {
  created: function () {
    if (!(this.$store.getters.variablesVisibilityConditionItems || []).length) {
      this.$store.dispatch(GET_CONDITION_VARIABLES_ACTION);
    }
  },
};
